import NewsDetail from './NewsDetail';

export default NewsDetail;
